import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError } from '#src/shared/error';

import { TopicSupporterVoices } from './api.graphql';
import type { TopicSupporterVoicesQuery, TopicSupporterVoicesQueryVariables } from './api.graphql';
import type { TopicPageSupporterVoices as BaseTopicPageSupporterVoices } from './types';

type TopicPageSupporterVoices = BaseTopicPageSupporterVoices & {
	/** Indicates whether signees must be hidden. */
	hideSignees: Readonly<TopicSupporterVoicesQuery['featureConfigs']['hideSignees']>;
};

export async function getData({ gql: { fetch } }: UtilityContext, slug: string): Promise<TopicPageSupporterVoices> {
	const { data } = await fetch<TopicSupporterVoicesQuery, TopicSupporterVoicesQueryVariables>({
		query: TopicSupporterVoices,
		variables: { slug },
		rejectOnError: true,
	});

	const supporterVoices = data.topicPageBySlug?.supporterVoices;

	if (!supporterVoices) {
		throw new NotFoundError();
	}

	return {
		...supporterVoices,
		comments: supporterVoices.comments.map((comment) => {
			if ('text' in comment) {
				return {
					...comment,
					// oxlint-disable-next-line typescript/no-unnecessary-type-conversion -- comment.id is a number on the wire despite the GraphQL type saying string (see tests)
					id: String(comment.id),
					type: 'text',
				};
			}
			return {
				...comment,
				// oxlint-disable-next-line typescript/no-unnecessary-type-conversion -- comment.id is a number on the wire despite the GraphQL type saying string (see tests)
				id: String(comment.id),
				type: 'video',
				petitionOriginalLocale: comment.petitionOriginalLocale.localeCode,
			};
		}),
		hideSignees: data.featureConfigs.hideSignees,
	};
}
